# Usage:
#   Place the <amount-inline-spinner> tag wherever needed on the page.
#   Instantiate by setting a display condition that is activated externally:
#     * iconName: String (optional; default: #icon-loading); the name of the icon image from the `icon-map.svg`
#     * loadingMessage: String or ApplicationCtrl-scoped variable (optional)
# Ex.:
#   <amount-inline-spinner
#     ng-show="show-condition expression goes here"
#     icon-name="#icon-loading"
#     loading-message="Generating loan options">
#   </amount-inline-spinner>

angular.module("avant.customer_applications.directives").directive "amountInlineSpinner", () ->
  restrict: 'E'
  scope:
    iconName: '@'
    loadingMessage: '@'
  template: '''
    <section class="loading__inline">
      <h2 class="loading__headline headline headline--light">
        {{ loadingMessage }}
      </h2>
      <amount-icon
        css-classes="loading__oval"
        icon-name="{{ iconName || '#icon-loading' }}">
      </amount-icon>
    </section>
  '''
